import { UrlTree } from '@angular/router';
import {
  createStaffAuthUrlTree,
  type StaffAuthRedirectDeps,
} from '@features/auth/utils/create-staff-auth-url-tree.util';
import { markWelcomeBeatPending } from '@features/auth/utils/welcome-beat.storage';

export function isOnboardAuthRedirect(urlTree: UrlTree): boolean {
  return urlTree.root.children['primary']?.segments[0]?.path === 'onboard';
}

/** Aplica contexto de compañía/sede y navega tras auth staff (email ya verificado). */
export function navigateAfterStaffAuth(options: StaffAuthRedirectDeps): Promise<boolean> {
  const urlTree = createStaffAuthUrlTree(options);
  if (isOnboardAuthRedirect(urlTree)) {
    markWelcomeBeatPending();
  }
  return options.router.navigateByUrl(urlTree, { replaceUrl: true });
}
